import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import {interactionsStore} from "../../stores/InteractionsStore";

function Parallax(props) {
    const {store, progress} = props;

    const images = [];
    const amt = Math.max(0.5, Math.min(progress, 1.25));
    let yStep = store.interactionsStore.clientWidth / 125;//keep aspect fixed
    let moveBy = yStep;
    const offsetAmt = 0;//-150 * (1 - Math.max(0, Math.min(1, progress)));

    for (let i = 0; i < 8; i++) {
        images.push({file: `d${i}.svg`, y: offsetAmt + i * moveBy * (1 - amt)});
        moveBy += yStep;
    }

    // console.log(`Parallax progress: ${progress} ${offsetAmt}`);
    return (
        <div className={'Parallax'}>
            {images.map(({file, y}, i) => <img className={'parallax-layer'} key={`p_${i}`} style={{top: y - 1}}
                                               width={'100%'}
                                               src={`img/layered/${file}`}
                                               alt={"rendering of Campanile tower and distant mountains"}/>)}
            <div className={'parallax-bottom'}>

            </div>
        </div>
    );
}

export default observer(Parallax);
